import UploadProfilePicture from './UploadProfilePicture';
export default UploadProfilePicture;